import { END_USER_MOBILE_FRAME_WIDTH_PX } from 'constants/endUserMobileLayout';

import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import DollarBillsImage from 'assets/images/dollorbills.png';
import ShaderBg from 'assets/images/Hsa-cashout-bg.png';

import { colors } from 'theme/colors';

export const HsaSuccessRoot = styled(Box)`
  position: fixed;
  inset: 0;
  min-height: 100vh;
  width: 100%;
  max-width: ${END_USER_MOBILE_FRAME_WIDTH_PX}px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${colors.button.dark};
  background-image: url(${ShaderBg});
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1500;
  padding: 48px 24px;
  gap: 24px;
  overflow: hidden;
`;

export const HsaSuccessDollarBills = styled('img')`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: ${END_USER_MOBILE_FRAME_WIDTH_PX}px;
  height: auto;
  pointer-events: none;
  user-select: none;
`;

export const HsaSuccessContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 72px;
`;

export const HsaSuccessIconOuterRing = styled(Box)`
  width: 104px;
  height: 104px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.14);
  border: 4px solid rgba(255, 255, 255, 0.46);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HsaSuccessIconInnerCircle = styled(Box)`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #12b76a;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HsaSuccessTitle = styled(Typography)`
  color: ${colors.background.main};
  font-weight: 700;
  text-align: center;
`;

export const HsaSuccessSubtitle = styled(Typography)`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
`;

export const HsaSuccessDollarBillsSrc = DollarBillsImage;
